export * from './promotion-carousel';
